import React, { useEffect, useState } from "react";
import TypeApi from "../../api/TypeApi";
import SourceApi from "../../api/SourceApi";
import GroupApi from "../../api/GroupApi";
import UserApi from "../../api/UserApi";
import StateApi from "../../api/StateApi";
import LeadAssignApi from "../../api/LeadAssignApi";
import { showSuccess, showError } from "../../utils/toastUtils";

function EditDetails({ data, onSuccess }) {
  const [typeList, setTypeList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [managerList, setManagerList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  const [form, setForm] = useState({
    id: "",
    typeId: "",
    sourceId: "",
    groupId: "",
    stateId: "",   
    state: "",
    district: "",
    pincode: "",
    managerId: "",
  });

  /* ================== LOAD MASTERS ================== */
  useEffect(() => {
    loadMasters();
    loadStates();
  }, []);

  /* ================== PREFILL ================== */
  useEffect(() => {
    if (!data) return;

    const stateObj = stateList.find(s => s.name === data.state);

    setForm({
      id: data._id,
      typeId: data.typeId?._id || "",
      sourceId: data.sourceId?._id || "",
      groupId: data.groupId?._id || "",
      stateId: stateObj?._id || "",
      state: data.state || "",
      district: data.district || "",
      pincode: data.pincode || "",
      managerId: data.managerId?._id || "",
    });

    if (stateObj?._id) {
      loadDistricts(stateObj._id);
    }
  }, [data, stateList]);

  /* ================== LOAD MASTERS (Fixed) ================== */
const loadMasters = async () => {
  try {
    // Promise.all ki jagah individual calls ya error handling use karein
    const [t, s, g, u] = await Promise.allSettled([
      TypeApi.list(),
      SourceApi.list(),
      GroupApi.list(),
      UserApi.list(),
    ]);

    if (t.status === "fulfilled" && t.value.code === 200) setTypeList(t.value.data);
    if (s.status === "fulfilled" && s.value.code === 200) setSourceList(s.value.data);
    if (g.status === "fulfilled" && g.value.code === 200) setGroupList(g.value.data);

    if (u.status === "fulfilled" && u.value.code === 200) {
      const managers = u.value.data.filter(
        (x) => x.roleId?.role?.toLowerCase() === "manager"
      );
      setManagerList(managers);
    } else {
      console.error("User list access denied or failed");
    }
  } catch (err) {
    console.error("Master loading failed:", err);
  }
};

  const loadStates = async () => {
    const res = await StateApi.getStates();
    //console.log(res.data)
    if (res.code === 200) setStateList(res.data);
  };

  const loadDistricts = async (stateId) => {
    if (!stateId) return;
    try {
      const res = await StateApi.getDistrictsByState(stateId);
      console.log(res.data)
      if (res.code === 200) setDistrictList(res.data);
      else setDistrictList([]);
    } catch {
      setDistrictList([]);
    }
  };

  /* ================== CHANGE HANDLER ================== */
  const handleChange = (e) => {
  const { name, value } = e.target;

  // ✅ PINCODE: only numbers + max 6
  if (name === "pincode") {
    const numericValue = value.replace(/\D/g, "").slice(0, 6);

    setForm((p) => ({
      ...p,
      pincode: numericValue,
    }));
    return;
  }

  if (name === "stateId") {
    const selectedState = stateList.find((s) => s._id === value);

    setForm((p) => ({
      ...p,
      stateId: value,
      state: selectedState?.name || "",
      district: "",
    }));

    loadDistricts(value);
    return;
  }

  setForm((p) => ({ ...p, [name]: value }));
};

  /* ================== SUBMIT ================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.managerId) {
      return showError("Manager is required");
    }

    // ✅ Remove empty values (CRITICAL)
    const payload = { id: form.id, managerId: form.managerId };

    if (form.typeId) payload.typeId = form.typeId;
    if (form.sourceId) payload.sourceId = form.sourceId;
    if (form.groupId) payload.groupId = form.groupId;
    if (form.state) payload.state = form.state;
    if (form.district) payload.district = form.district;
    if (form.pincode) payload.pincode = form.pincode;

    const res = await LeadAssignApi.update(payload);

    if (res.code === 200) {
      showSuccess(res.message);
      document
        .querySelector("#edit-leadassign-modal .btn-close")
        ?.click();
      onSuccess();
    } else {
      showError(res.message || "Update failed");
    }
  };

  /* ================== UI ================== */
  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Edit Lead Assignment</h4>
          <button className="btn-close" data-bs-dismiss="modal" />
        </div>

        <form onSubmit={handleSubmit} className="p-3">
          <div className="row">

            <Select label="Type" name="typeId" value={form.typeId} list={typeList} labelKey="type" onChange={handleChange} />
            <Select label="Source" name="sourceId" value={form.sourceId} list={sourceList} labelKey="source" onChange={handleChange} />
            <Select label="Group" name="groupId" value={form.groupId} list={groupList} labelKey="group" onChange={handleChange} />

            {/* ✅ STATE BY ID */}
            <Select
              label="State"
              name="stateId"
              value={form.stateId}
              list={stateList}
              labelKey="name"
              onChange={handleChange}
            />

            <Select
              label="District"
              name="district"
              value={form.district}
              list={districtList}
              labelKey="name"
              onChange={handleChange}
              disabled={!form.stateId}
            />

            <div className="col-md-4 mb-3">
              <label>Pincode</label>
              <input
                name="pincode"
                value={form.pincode}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <Select
              label="Assign To Manager"
              name="managerId"
              value={form.managerId}
              list={managerList}
              labelKey="name"
              onChange={handleChange}
              col="12"
            />
          </div>

          <div className="text-end">
            <button className="btn btn-light me-2" data-bs-dismiss="modal">
              Cancel
            </button>
            <button className="btn btn-primary">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
}

/* ================== REUSABLE SELECT ================== */
const Select = ({ label, name, value, list, labelKey, onChange, col = 4, disabled }) => (
  <div className={`col-md-${col} mb-3`}>
    <label>{label}</label>
    <select
      className="form-select"
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      <option value="">Select {label}</option>
      {list.map(i => (
        <option key={i._id} value={i._id}>
          {i[labelKey]}
        </option>
      ))}
    </select>
  </div>
);

export default EditDetails;
